/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './tab.module.scss';

const Tab = ({
  label,
  onClick,
  activeTab,
  activeTabClass = '',
  tabId,
  toggleDropdown,
  gtmClass = '',
  showResults = false,
  results,
  showIcon = false,
  icon = null,
  disabled = false
}) => {
  // eslint-disable-next-line no-nested-ternary
  const className = activeTab === tabId 
  ? activeTabClass !== '' 
    ? ` ${styles[activeTabClass] || ''}` 
    : ` ${styles?.active || ''}` 
  : '';

  return (
    <li className={styles?.tabListItem || ''}>
      <button
        className={`${className || ''} ${gtmClass || ''} tabs-menu-gtm btn-cta`}
        type="button"
        onClick={() => {
          onClick(tabId);
          toggleDropdown();
        }}
        disabled={disabled}
      >
        {label}
        {showResults && <span>{results}</span>}
        {showIcon && icon}
      </button>
    </li>
  );
};
Tab.propTypes = {
  onClick: PropTypes.func,
  toggleDropdown: PropTypes.func,
  activeTab: PropTypes.string,
  activeTabClass: PropTypes.string,
  tabId: PropTypes.string,
  label: PropTypes.string,
  gtmClass: PropTypes.string,
  showIcon: PropTypes.bool,
  showResults: PropTypes.bool,
  results: PropTypes.number,
  icon: PropTypes.func,
  disabled: PropTypes.bool
};

export default Tab;
